import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const PriceMatrix = lazy(() => import(/* webpackChunkName: "PriceMatrix" */ './components/PriceMatrix'));

const priceMatrices = document.querySelectorAll('#price-matrix');
if (priceMatrices != null) {
    priceMatrices.forEach(priceMatrix => {
        const props = parseDatasetToProps(priceMatrix.dataset);

        render(
            <Suspense fallback={<></>}>
                <PriceMatrix
                    {...props}
                />
            </Suspense>,
            priceMatrix
        );
    })
}
